import utils from '@src/common/utils'
import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '1000px',
    emptyText: '暂无数据',
    column: [
      {
        label: '唯一标识号',
        prop: 'thirdDeviceId',
        align: 'center',
        overHidden: true
      },
      // {
      //   label: '系统类型',
      //   prop: 'deviceMark',
      //   align: 'center',
      //   overHidden: true,
      //   type: 'select',
      //   dicData: Dic.find('SENU087'),
      //   viewFormatter: (row, value) => {
      //     return Dic.findByValue('SENU087', Number(value))
      //   },
      //   formatter: function (row, value) {
      //     return value ? Dic.findByValue('SENU087', value) : ''
      //   },
      // },
      // {
      //   label: '系统地址',
      //   prop: 'parentMac',
      //   overHidden: true,
      //   align: 'center'
      // },
      // {
      //   label: '类型标志',
      //   prop: 'typeMark',
      //   overHidden: true
      // },
      // {
      //   label: '回路',
      //   prop: 'loop',
      //   align: 'center',
      //   overHidden: true
      // },
      {
        label: '部件类型',
        prop: 'subDeviceMark',
        type: 'select',
        dicData: Dic.find('SENU094'),
        viewFormatter: (row, value) => {
          return Dic.findByValue('SENU094', Number(value))
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue('SENU094', value) : ''
        },
      },
      {
        label: '部件地址',
        prop: "subDeviceMac",
        align: 'center',
        overHidden: true
      },
      {
        label: '部件说明',
        prop: "thirdDeviceDesc",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        span: 24,
        type: 'textarea',
        minRows: 3,
        maxlength: 200,
      },
      {
        label: '时间',
        prop: "recordTime",
        overHidden: true,
        addDisplay: false,
        viewDisplay: true,
      },
      {
        label: "运行状态",
        prop: "statusDesc",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        // type: 'select',
        // dicData: [
        //   {
        //     label: '在线',
        //     value: '1'
        //   },
        //   {
        //     label: '离线',
        //     value: '0'
        //   }
        // ],
        // formatter: function (row, value) {
        //   return Number(value) === 1 ? '在线' : '离线'
        // },
        // viewFormatter: (row, value) => {
        //   return Number(value) === 1 ? '在线' : '离线'
        // },
      },
      {
        label: '上报码流',
        prop: "data",
        overHidden: true,
        addDisplay: false,
        viewDisplay: true
      },
    ],
  }
}
export default tableOption
